module.exports = __webpack_public_path__ + "static/media/ps-site800w.4e262925.webp";